module.exports = __webpack_public_path__ + "static/showreel_clip-f34ea438027d1765db5b045bdddc3694.mp4";